/**
 * Reads a field from a value of unknown shape, such as a generic list option or
 * a loosely typed third-party event; a missing field yields `undefined`.
 */
export function readField(value: unknown, key: string): unknown {
  if (typeof value !== 'object' || value === null || !(key in value)) {
    return undefined;
  }
  return Reflect.get(value, key);
}

export function optionName(option: unknown): string {
  const name = readField(option, 'name');
  return name === undefined || name === null ? '' : String(name);
}
